export default {
  newRoutes: [
    {
      path: '/',
      routes: [
        {
          exact: true,
          path: '/',
          pageType: 'home'
        },
        {
          exact: true,
          path: '/feature',
          pageType: 'feature'
        },
        {
          exact: true,
          path: '/top-sellers',
          pageType: 'popular'
        },
        {
          exact: true,
          path: '/popular_item/by_category',
          pageType: 'popular'
        },
        {
          path: '/free/:page',
          pageType: 'landing'
        },
        {
          path: '/all-graphics/pg-:page(\\d+)',
          pageType: 'category'
        },
        {
          path: '/all-graphics',
          pageType: 'category'
        },
        {
          path: '/graphics-with-:term-in-:category([\\w/-]+)/pg-:page(\\d+)',
          pageType: 'category'
        },
        {
          path: '/graphics-with-:term-in-:category([\\w/-]+)',
          pageType: 'category'
        },
        {
          path:
            '/:term-and-:tags-graphics-in-:category([\\w/-]+)/pg-:page(\\d+)',
          pageType: 'category'
        },
        {
          path: '/:term-and-:tags-graphics-in-:category([\\w/-]+)',
          pageType: 'category'
        },
        {
          path: '/:term-and-:tags-graphics/pg-:page(\\d+)',
          pageType: 'tag'
        },
        {
          path: '/:term-and-:tags-graphics',
          pageType: 'tag'
        },
        {
          path: '/:tags-graphics-in-:category([\\w/-]+)/pg-:page(\\d+)',
          pageType: 'category'
        },
        {
          path: '/:tags-graphics-in-:category([\\w/-]+)',
          pageType: 'category'
        },
        {
          path: '/:term-in-graphics/pg-:page(\\d+)',
          pageType: 'search'
        },
        {
          path: '/:term-in-graphics',
          pageType: 'search'
        },
        {
          path: '/:tags-graphics/pg-:page(\\d+)',
          pageType: 'tag'
        },
        {
          path: '/:tags-graphics',
          pageType: 'tag'
        },
        {
          path: '/attributes/:attribute_key/:attribute_value',
          pageType: 'attribute'
        },
        {
          path: '/:category+/pg-:page(\\d+)',
          pageType: 'category'
        },
        {
          path: '/:category+',
          pageType: 'category'
        },
        {
          path: '/*',
          pageType: 'other'
        }
      ]
    }
  ],
  oldRoutes: [
    {
      path: '/',
      routes: [
        {
          exact: true,
          path: '/',
          pageType: 'home'
        },
        {
          exact: true,
          path: '/feature',
          pageType: 'feature'
        },
        {
          exact: true,
          path: '/top-sellers',
          pageType: 'popular'
        },
        {
          exact: true,
          path: '/popular_item/by_category',
          pageType: 'popular'
        },
        {
          path: '/free/:page',
          pageType: 'landing'
        },
        {
          path: '/category/*',
          pageType: 'category'
        },
        {
          path: '/tags/:tags',
          pageType: 'tag'
        },
        {
          path: '/attributes/:key/:value',
          pageType: 'attribute'
        },
        {
          path: '/search',
          pageType: 'search'
        },
        {
          path: '/*',
          pageType: 'other'
        }
      ]
    }
  ]
}
